import React from 'react';
import { useRef } from 'react';
import './styles/Anmeldung.css';
import { Link } from 'react-router-dom';
import { Button, Grid2, MenuItem, TextField} from '@mui/material';
import {Radio} from '@mui/material';
import {RadioGroup} from '@mui/material';
import { FormControl } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import {FormControlLabel} from '@mui/material';
import { useNavigate } from 'react-router';

function Anmeldung() {
    const [isFormVisible, setIsFormVisible] = React.useState(true);
    const formHeader = useRef(null);
    const validationHeader = useRef(null);
    const navigate = useNavigate();

    const validationSchema = yup.object({
        teilnahmeZeitraum: yup.string().required("teilnahmeZeitraum ist erforderlich"),
        vorname: yup.string().required("Vorname ist erforderlich"),
        nachname: yup.string().required("Nachname ist erforderlich"),
        geschlecht: yup.string().required("Geschlecht ist erforderlich"),
        geburtstag: yup.date().required("Geburtstag ist erforderlich"),
        strasse: yup.string().required("Straße ist erforderlich"),
        hausnummer: yup.string().required("Hausnummer ist erforderlich"),
        plz: yup.string().required("Postleitzahl ist erforderlich"),
        ort: yup.string().required("Ort ist erforderlich"),
        telefonFestnetz: yup.string().required("Telefonnummer Festnetz ist erforderlich"),
        telefonMobil1: yup.string().required("Telefonnummer Mobil 1 ist erforderlich"),
        email: yup.string().email("E-Mail ist nicht gültig").required("E-Mail ist erforderlich"),
        schwimmen: yup.string().required("Einverständnis Schwimmen ist erforderlich"),
        behandlung: yup.string()/*.test(
            'is-specific-value',
            'Einverständnis zur ärztlichen Behandlung ist erforderlich',
            (value) => value === 'Ja' // Überprüft auf den spezifischen Wert
          )*/.required("Einverständnis zur ärztlichen Behandlung ist erforderlich"),
        behandlungBetreuer: yup.string()/*.test(
            'is-specific-value',
            'Einverständnis zur Behandlung durch Betreuer ist erforderlich',
            (value) => value === 'Ja' // Überprüft auf den spezifischen Wert
          )*/.required("Einverständnis zur Behandlung durch Betreuer ist erforderlich"),
        einverstaendnisFotos: yup.string()/*.test(
            'is-specific-value',
            'Einverständnis zur Nutzung von Fotos ist erforderlich',
            (value) => value === 'Ja' // Überprüft auf den spezifischen Wert
          )*/.required("Einverständnis zur Nutzung von Fotos ist erforderlich"),
        einverstaendnisAktivitaeten: yup.string()/*.test(
            'is-specific-value',
            'Einverständnis für Aktivitäten ist erforderlich',
            (value) => value === 'Ja' // Überprüft auf den spezifischen Wert
          )*/.required("Einverständnis für Aktivitäten ist erforderlich"),
    });

    const formik = useFormik({
        initialValues: {
            teilnahmeZeitraum: "03.08.2026 - 14.08.2026",
            vorname: "",
            nachname: "",
            geschlecht: "",
            geburtstag: "2010-01-01",
            strasse: "",
            hausnummer: "",
            plz: "",
            ort: "",
            telefonFestnetz: "",
            telefonMobil1: "",
            telefonMobil2: "",
            email: "",
            schwimmen: "Ja",
            baden: "Ja",
            behandlung: "Ja",
            behandlungBetreuer: "Ja",
            einverstaendnisFotos: "Ja",
            einverstaendnisAktivitaeten: "Ja",
            schreberjugendMitglied: "Nein",
            allergien: "",
            anmerkungen: "",
            angeworben: "",
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            setIsFormVisible(false);

            setTimeout(() => {
                if (validationHeader.current) {
                    validationHeader.current.scrollIntoView({ behavior: 'smooth' });
                }
            }, 0);
        },
    });

    const handleSubmit = async () => {
        try {
            const dev = false;
            let api_url = "";
    
            if (dev) {
                api_url = "http://localhost:90/public/api/postApplication.php";
            } else {
                api_url = "/api/postApplication.php"
            }
    
            const response = await fetch(api_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    'year': 2026,
                    'data': formik.values,
                }),
            });
            const data = await response.json();
            const hasError = data.some(result => result.success === false);

            if (hasError) {
                // Umleiten auf Fehlerseite
                navigate('/anmeldung/fail');
            } else {
                // Umleiten auf Erfolgsseite
                navigate('/anmeldung/success');
            }
        } catch (error) {
            navigate('/anmeldung/fail');
        }
    }


    return(
        <div className='anmeldungContainer'>
            <div className='anmeldungContentContainer'>
                <div className='anmeldungTextContainer'>
                    <h1>Zeltlager 2026 - Anmeldung</h1>
                    <p>Anmeldung zum Ferienzeltlager der Schreberjugend Landesverband Südwest vom 03.08. bis 14.08.2026 in Bodman.<br/>
                    Per Mail an zeltlager@schreberjugend-suedwest.de können Sie mit uns in Kontakt treten.</p>
                    <p style={{fontWeight: 'bold', marginBottom: '0px'}}>Preise:</p>
                    <table className='anmeldungPriceTable'>
                        <tbody>
                            <tr>
                                <td style={{paddingTop: '10px'}}>bei Buchung bis zum 28.02.2026</td>
                                <td style={{paddingTop: '10px'}}>400€</td>
                            </tr>
                            <tr>
                                <td style={{paddingTop: '10px'}}>bei Buchung dem 01.03.2026</td>
                                <td style={{paddingTop: '10px'}}>420€</td>
                            </tr>
                            <tr>
                                <td style={{paddingTop: '30px'}}>Teilnahme vom 03. - 09.08.2026, 7 Tage<br/>(Voraussetzung ist das Abholen des Kindes)</td>
                                <td style={{paddingTop: '30px'}}>250€</td>
                            </tr>
                            <tr>
                                <td style={{paddingTop: '10px'}}>Teilnahme vom 09. - 14.08.2026, 6 Tage<br/>(Voraussetzung ist das Bringen des Kindes)</td>
                                <td style={{paddingTop: '10px'}}>250€</td>
                            </tr>
                            <tr>
                                <td style={{paddingTop: '10px'}}>Geschwisterkind-Rabatt und Mitgliedsrabatt</td>
                                <td style={{paddingTop: '10px'}}>10€</td>
                            </tr>
                            <tr>
                                <td style={{paddingTop: '10px'}}>Rabatt pro NEU angworbenem Teilnehmenden</td>
                                <td style={{paddingTop: '10px'}}>10€</td>
                            </tr>
                        </tbody>
                    </table>
                    <br/>
                    <p style={{fontWeight: 'bold', marginBottom: '0px'}}>Kann ich mir das leisten?</p>
                    <p>Ja! Eine Teilnahme sollte nicht am Geld scheitern. Für die benatragung von zuschüssen treten Sie bitte mit uns in Kontakt</p>
                </div>
                {
                    isFormVisible ? (
                        <div className='anmeldungFormContainer'>
                            <h3 ref={formHeader} style={{scrollMarginTop: "100px"}}>Anmeldeformular</h3>
                            <p>Hiermit melde ich meine(n) Tochter/Sohn verbindlich zur Teilnahme an dieser Ferienfreizeit an:</p>
                            <p>Bitte füllen Sie das Formular vollständig aus.<br/>
                            <i style={{color: 'lightgray'}}>* Pflichtfelder</i>
                            {/*<br/><i style={{color: 'lightgray'}}>** Zustimmung ist erforderlich zur Teilnahme</i> */}
                            </p>
                            <br/>
                            <form onSubmit={formik.handleSubmit}>
                                <Grid2 container spacing={2.5}>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Teilnahmezeitraum*</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 9}}>
                                        <TextField
                                            name="teilnahmeZeitraum"
                                            label="Teilnahmezeitraum"
                                            value={formik.values.teilnahmeZeitraum}
                                            onChange={formik.handleChange}
                                            error={formik.touched.teilnahmeZeitraum && Boolean(formik.errors.teilnahmeZeitraum)}
                                            className='anmeldungSelectZeitraum'
                                            select
                                            required
                                        >
                                            <MenuItem value="03.08.2026 - 14.08.2026">03.08.2026 - 14.08.2026 (gesamter Zeitraum)</MenuItem>
                                            <MenuItem value="03.08.2026 - 09.08.2026">03.08.2026 - 09.08.2026 (1. Woche)</MenuItem>
                                            <MenuItem value="09.08.2026 - 14.08.2026">09.08.2026 - 14.08.2026 (2. Woche)</MenuItem>
                                        </TextField>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Vorname der/des Teilnehmenden*</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <TextField 
                                            label="Vorname" 
                                            name="vorname" 
                                            value={formik.values.vorname} 
                                            onChange={formik.handleChange} 
                                            error={formik.touched.vorname && Boolean(formik.errors.vorname)} 
                                            helperText={formik.touched.vorname && formik.errors.vorname}
                                            margin='normal'
                                            required
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Nachname der/des Teilnehmenden*</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <TextField 
                                            label="Nachname" 
                                            name="nachname" 
                                            value={formik.values.nachname} 
                                            onChange={formik.handleChange} 
                                            error={formik.touched.nachname && Boolean(formik.errors.nachname)} 
                                            helperText={formik.touched.nachname && formik.errors.nachname}
                                            margin='normal'
                                            required
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Geschlecht der/des Teilnehmenden*</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <FormControl component="fieldset" margin="normal" required>
                                            <RadioGroup
                                                name="geschlecht"
                                                value={formik.values.geschlecht}
                                                onChange={formik.handleChange}
                                                row
                                            >
                                            <FormControlLabel value="weiblich" control={<Radio />} label="Weiblich" />
                                            <FormControlLabel value="männlich" control={<Radio />} label="Männlich" />
                                            <FormControlLabel value="divers" control={<Radio />} label="Divers" />
                                            </RadioGroup>
                                            {formik.touched.geschlecht && formik.errors.geschlecht && (
                                            <div style={{ color: 'red' }}>{formik.errors.geschlecht}</div>
                                            )}
                                        </FormControl>   
                                    </Grid2>        
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Geburtstag des/der Teilnehmenden*</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <TextField 
                                            type='date'
                                            label="Geburtstag" 
                                            name="geburtstag" 
                                            InputLabelProps={{ shrink: true, required: true }}
                                            value={formik.values.geburtstag} 
                                            onChange={formik.handleChange} 
                                            error={formik.touched.geburtstag && Boolean(formik.errors.geburtstag)} 
                                            helperText={formik.touched.geburtstag && formik.errors.geburtstag}
                                            margin='normal'
                                            required
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Straße/Hausnummer*</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <TextField 
                                            label="Straße" 
                                            name="strasse" 
                                            value={formik.values.strasse} 
                                            onChange={formik.handleChange} 
                                            error={formik.touched.strasse && Boolean(formik.errors.strasse)} 
                                            helperText={formik.touched.strasse && formik.errors.strasse}
                                            margin='normal'
                                            required
                                            style={{ marginRight: 10 }}
                                        />
                                        <TextField
                                            label="Hausnummer"
                                            name="hausnummer"
                                            value={formik.values.hausnummer}
                                            onChange={formik.handleChange}
                                            error={formik.touched.hausnummer && Boolean(formik.errors.hausnummer)}
                                            helperText={formik.touched.hausnummer && formik.errors.hausnummer}
                                            margin='normal'
                                            required
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Postleitzahl/Ort*</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <TextField
                                            label="Postleitzahl"
                                            name="plz"
                                            value={formik.values.plz}
                                            onChange={formik.handleChange}
                                            error={formik.touched.plz && Boolean(formik.errors.plz)}
                                            helperText={formik.touched.plz && formik.errors.plz}
                                            margin='normal'
                                            required
                                            style={{ marginRight: 10 }}
                                        />
                                        <TextField
                                            label="Ort"
                                            name="ort"
                                            value={formik.values.ort}
                                            onChange={formik.handleChange}
                                            error={formik.touched.ort && Boolean(formik.errors.ort)}
                                            helperText={formik.touched.ort && formik.errors.ort}
                                            margin='normal'
                                            required
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Telefonische Erreichbarkeit Festnetz*</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <TextField
                                            label="Telefonnummer Festnetz"
                                            name="telefonFestnetz"
                                            value={formik.values.telefonFestnetz}
                                            onChange={formik.handleChange}
                                            error={formik.touched.telefonFestnetz && Boolean(formik.errors.telefonFestnetz)}
                                            helperText={formik.touched.telefonFestnetz && formik.errors.telefonFestnetz}
                                            margin='normal'
                                            required
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Telefonische Erreichbarkeit Mobil 1*</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <TextField
                                            label="Telefonnummer Mobil 1"
                                            name="telefonMobil1"
                                            value={formik.values.telefonMobil1}
                                            onChange={formik.handleChange}
                                            error={formik.touched.telefonMobil1 && Boolean(formik.errors.telefonMobil1)}
                                            helperText={formik.touched.telefonMobil1 && formik.errors.telefonMobil1}
                                            margin='normal'
                                            required
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Telefonische Erreichbarkeit Mobil 2</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <TextField
                                            label="Telefonnummer Mobil 2"
                                            name="telefonMobil2"
                                            value={formik.values.telefonMobil2}
                                            onChange={formik.handleChange}
                                            error={formik.touched.telefonMobil2 && Boolean(formik.errors.telefonMobil2)}
                                            helperText={formik.touched.telefonMobil2 && formik.errors.telefonMobil2}
                                            margin='normal'
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>E-Mail Adresse eines Erziehungsberechtigten*</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <TextField
                                            label="E-Mail Adresse"
                                            name="email"
                                            value={formik.values.email}
                                            onChange={formik.handleChange}
                                            error={formik.touched.email && Boolean(formik.errors.email)}
                                            helperText={formik.touched.email && formik.errors.email}
                                            margin='normal'
                                            required
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Die/der Teilnehmende kann schwimmen*</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <FormControl component="fieldset" margin="normal" required>
                                            <RadioGroup
                                                name="schwimmen"
                                                value={formik.values.schwimmen}
                                                onChange={formik.handleChange}
                                                row
                                            >
                                            <FormControlLabel value="Ja" control={<Radio />} label="Ja" />
                                            <FormControlLabel value="Nein" control={<Radio />} label="Nein" />
                                            </RadioGroup>
                                            {formik.touched.schwimmen && formik.errors.schwimmen && (
                                            <div style={{ color: 'red' }}>{formik.errors.schwimmen}</div>
                                            )}
                                        </FormControl>     
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Der Teilnehmer darf Baden*</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <FormControl component="fieldset" margin="normal" required>
                                            <RadioGroup
                                                name="baden"
                                                value={formik.values.baden}
                                                onChange={formik.handleChange}
                                                row
                                            >
                                            <FormControlLabel value="Ja" control={<Radio />} label="Ja" />
                                            <FormControlLabel value="Nein" control={<Radio />} label="Nein" />
                                            </RadioGroup>
                                            {formik.touched.baden && formik.errors.baden && (
                                            <div style={{ color: 'red' }}>{formik.errors.baden}</div>
                                            )}
                                        </FormControl> 
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>    
                                        <p>Einverständniserklärung, dass der/die Teilnehmer/in im Krankheitsfalle in ärztliche Behandlung gegeben werden darf.*</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <FormControl component="fieldset" margin="normal" required>
                                            <RadioGroup
                                                name="behandlung"
                                                value={formik.values.behandlung}
                                                onChange={formik.handleChange}
                                                row
                                            >
                                            <FormControlLabel value="Ja" control={<Radio />} label="Ja" />
                                            <FormControlLabel value="Nein" control={<Radio />} label="Nein" />
                                            </RadioGroup>
                                            {formik.touched.behandlung && formik.errors.behandlung && (
                                            <div style={{ color: 'red' }}>{formik.errors.behandlung}</div>
                                            )}
                                        </FormControl> 
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>        
                                        <p>Einverständniserklärung, dass Zecken von den Betreuern entfernt werden dürfen und kleinere Wunden von den Betreuern versorgt werden dürfen.*</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <FormControl component="fieldset" margin="normal" required>
                                            <RadioGroup
                                                name="behandlungBetreuer"
                                                value={formik.values.behandlungBetreuer}
                                                onChange={formik.handleChange}
                                                row
                                            >
                                            <FormControlLabel value="Ja" control={<Radio />} label="Ja" />
                                            <FormControlLabel value="Nein" control={<Radio />} label="Nein" />
                                            </RadioGroup>
                                            {formik.touched.behandlungBetreuer && formik.errors.behandlungBetreuer && (
                                            <div style={{ color: 'red' }}>{formik.errors.behandlungBetreuer}</div>
                                            )}
                                        </FormControl>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Einverständniserklärung zur evtl. Veröffentlichung von Fotos im Internet oder auf Printmedien auf denen mein Kind abgelichtet ist.*</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <FormControl component="fieldset" margin="normal" required>
                                            <RadioGroup
                                                name="einverstaendnisFotos"
                                                value={formik.values.einverstaendnisFotos}
                                                onChange={formik.handleChange}
                                                row
                                            >
                                            <FormControlLabel value="Ja" control={<Radio />} label="Ja" />
                                            <FormControlLabel value="Nein" control={<Radio />} label="Nein" />
                                            </RadioGroup>
                                            {formik.touched.einverstaendnisFotos && formik.errors.einverstaendnisFotos && (
                                            <div style={{ color: 'red' }}>{formik.errors.einverstaendnisFotos}</div>
                                            )}
                                        </FormControl>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Ich bin damit einverstanden, dass mein Kind in Kleingruppen altersgemäße Aktivitäten ohne Aufsicht, jedoch nach Erlaubnis der Lagerleitung, unternehmen darf.*</p> 
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <FormControl component="fieldset" margin="normal" required>
                                            <RadioGroup
                                                name="einverstaendnisAktivitaeten"
                                                value={formik.values.einverstaendnisAktivitaeten}
                                                onChange={formik.handleChange}
                                                row
                                            >
                                            <FormControlLabel value="Ja" control={<Radio />} label="Ja" />
                                            <FormControlLabel value="Nein" control={<Radio />} label="Nein" />
                                            </RadioGroup>
                                            {formik.touched.einverstaendnisAktivitaeten && formik.errors.einverstaendnisAktivitaeten && (
                                            <div style={{ color: 'red' }}>{formik.errors.einverstaendnisAktivitaeten}</div>
                                            )}
                                        </FormControl>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Schreberjugend Mitglied</p> 
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 9 }}>
                                        <FormControl component="fieldset" margin="normal">
                                            <RadioGroup
                                                name="schreberjugendMitglied"
                                                value={formik.values.schreberjugendMitglied}
                                                onChange={formik.handleChange}
                                                row
                                            >
                                            <FormControlLabel value="Ja" control={<Radio />} label="Ja" />
                                            <FormControlLabel value="Nein" control={<Radio />} label="Nein" />
                                            </RadioGroup>
                                            {formik.touched.schreberjugendMitglied && formik.errors.schreberjugendMitglied && (
                                            <div style={{ color: 'red' }}>{formik.errors.schreberjugendMitglied}</div>
                                            )}
                                        </FormControl>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Bitte unbedingt sämtliche Allergien, deren Auswirkungen und Gegenmaßnahmen mitteilen <br/>(z.B. bestimmte Lebensmittel-unverträglichkeiten etc.)</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>   
                                        <TextField
                                            label="Allergien"
                                            name="allergien"
                                            value={formik.values.allergien}
                                            onChange={formik.handleChange}
                                            error={formik.touched.allergien && Boolean(formik.errors.allergien)}
                                            helperText={formik.touched.allergien && formik.errors.allergien}
                                            margin='normal'
                                            multiline
                                            rows={4}
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Sonstige Anmerkungen</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <TextField
                                            label="Anmerkungen"
                                            name="anmerkungen"
                                            value={formik.values.anmerkungen}
                                            onChange={formik.handleChange}
                                            error={formik.touched.anmerkungen && Boolean(formik.errors.anmerkungen)}
                                            helperText={formik.touched.anmerkungen && formik.errors.anmerkungen}
                                            margin='normal'
                                            multiline
                                            rows={4}
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <p>Angeworben durch</p>
                                    </Grid2>
                                    <Grid2 size={{ xs: 6, md: 3 }}>
                                        <TextField
                                            label="vollständiger Name"
                                            name="angeworben"
                                            value={formik.values.angeworben}
                                            onChange={formik.handleChange}
                                            error={formik.touched.angeworben && Boolean(formik.errors.angeworben)}
                                            helperText={formik.touched.angeworben && formik.errors.angeworben}
                                            margin='normal'
                                        />
                                    </Grid2>
                                </Grid2>
                                <br/>
                                <p>Durch das Abschicken dieses Formulares werden die <a href="/assets/documents/Teilnahmebedingungen.pdf" target="_blank" rel="noopener noreferrer">Teilnahmebedingungen</a> zur Teilnahme an dieser Ferienfreizeit anerkannt. Innerhalb der nächsten Tage wird eine Bestätigungsmail mit weiteren Informationen an die im Email-Adressfeld angegebene Adresse verschickt.</p>
                                <Button type="submit" variant="contained" color="primary" sx={{ backgroundColor: '#95c11f', color: 'black' }}>
                                    Überprüfen
                                </Button>
                            </form>
                        </div>    
                    ) : (
                        <div className='anmeldungValidationContainer'>
                            <h3 ref={validationHeader} style={{scrollMarginTop: "100px"}}>Überprüfen Sie Ihre Angaben</h3>
                            <table className='anmeldungValidationTable'>
                            <tbody>
                                <tr>
                                    <td>Teilnahmezeitraum:</td>
                                    <td>{formik.values.teilnahmeZeitraum}</td>
                                </tr>
                                <tr>
                                    <td>Vorname:</td>
                                    <td>{formik.values.vorname}</td>
                                </tr>
                                <tr>
                                    <td>Nachname:</td>
                                    <td>{formik.values.nachname}</td>
                                </tr>
                                <tr>
                                    <td>Geschlecht:</td>
                                    <td>{formik.values.geschlecht}</td>
                                </tr>
                                <tr>
                                    <td>Geburtstag:</td>
                                    <td>
                                        {
                                            new Date(formik.values.geburtstag).toLocaleDateString('de-DE', {
                                                year: 'numeric',
                                                month: '2-digit',
                                                day: '2-digit'
                                            })
                                        }                                    
                                    </td>
                                </tr>
                                <tr>
                                    <td>Straße:</td>
                                    <td>{formik.values.strasse}</td>
                                </tr>
                                <tr>
                                    <td>Hausnummer:</td>
                                    <td>{formik.values.hausnummer}</td>
                                </tr>
                                <tr>
                                    <td>Postleitzahl:</td>
                                    <td>{formik.values.plz}</td>
                                </tr>
                                <tr>
                                    <td>Ort:</td>
                                    <td>{formik.values.ort}</td>
                                </tr>
                                <tr>
                                    <td>Telefonnummer Festnetz:</td>
                                    <td>{formik.values.telefonFestnetz}</td>
                                </tr>
                                <tr>
                                    <td>Telefonnummer Mobil 1:</td>
                                    <td>{formik.values.telefonMobil1}</td>
                                </tr>
                                <tr>
                                    <td>Telefonnummer Mobil 2:</td>
                                    <td>{formik.values.telefonMobil2}</td>
                                </tr>
                                <tr>
                                    <td>E-Mail-Adresse:</td>
                                    <td>{formik.values.email}</td>
                                </tr>
                                <tr>
                                    <td>Die/der Teilnehmende kann schwimmen:</td>
                                    <td>{formik.values.schwimmen}</td>
                                </tr>
                                <tr>
                                    <td>Die/der Teilnehmende darf baden:</td>
                                    <td>{formik.values.baden}</td>
                                </tr>
                                <tr>
                                    <td>Einverständniserklärung, dass der/die Teilnehmer/in im Krankheitsfalle in ärztliche Behandlung gegeben werden darf:</td>
                                    <td>{formik.values.behandlung}</td>
                                </tr>
                                <tr>
                                    <td>Einverständniserklärung, dass Zecken von den Betreuern entfernt werden dürfen und kleinere Wunden von den Betreuern versorgt werden dürfen:</td>
                                    <td>{formik.values.behandlungBetreuer}</td>
                                </tr>
                                <tr>
                                    <td>Einverständniserklärung zur evtl. Veröffentlichung von Fotos im Internet oder auf Printmedien auf denen mein Kind abgelichtet ist:</td>
                                    <td>{formik.values.einverstaendnisFotos}</td>
                                </tr>
                                <tr>
                                    <td>Ich bin damit einverstanden, dass mein Kind in Kleingruppen altersgemäße Aktivitäten ohne Aufsicht, jedoch nach Erlaubnis der Lagerleitung, unternehmen darf:</td>
                                    <td>{formik.values.einverstaendnisAktivitaeten}</td>
                                </tr>
                                <tr>
                                    <td>Schreberjugend Mitglied:</td>
                                    <td>{formik.values.schreberjugendMitglied}</td>
                                </tr>
                                <tr>
                                    <td>Allergien:</td>
                                    <td>{formik.values.allergien}</td>
                                </tr>
                                <tr>
                                    <td>Sonstige Anmerkungen:</td>
                                    <td>{formik.values.anmerkungen}</td>
                                </tr>
                                <tr>
                                    <td>Angeworben durch:</td>
                                    <td>{formik.values.angeworben}</td>
                                </tr>
                            </tbody>
                            </table>
                            <br/>
                            <Button 
                                onClick={() => {
                                    setIsFormVisible(true);             
                                    setTimeout(() => {
                                        if (formHeader.current) {
                                            formHeader.current.scrollIntoView({ behavior: 'smooth'});
                                        }
                                        }, 0);
                                    }} 
                                variant='outlined' style={{marginRight: "50px"}} 
                                sx={{ borderColor: 'black', color: 'black' }}
                            >
                                Angaben ändern
                            </Button>
                            <Button 
                                variant='contained' 
                                sx={{ backgroundColor: '#95c11f', color: 'black' }}
                                onClick={() => handleSubmit()}
                            >
                                Bestätigen
                            </Button>
                        </div>
                    )
                }
            </div>
            <div className='bottomContainer'>
                <Link to='https://deutsche-schreberjugend.de/'>
                    <p> Deutsche Schreberjugend</p>
                </Link>
                <Link to={'/impressum'}>
                    <p>Impressum</p>
                </Link>
                <Link to={'/datenschutz'}>
                    <p>Datensschutz</p>
                </Link>
            </div>
        </div>
    );
}

export default Anmeldung;